<template>
  <div class="row">
    <div class="col-lg-8">
      <h2 class="inline">Inspection Report</h2>
    </div>
    <div class="col-lg-4 style-date">
      <span>Select Date Range</span>
      <el-date-picker
        v-model="selectDate"
        type="daterange"
        range-separator="To"
        start-placeholder="Start date"
        end-placeholder="End date"
        @change="getDateRange()"
      ></el-date-picker>
    </div>
    <div class="col-lg-4 style-select">
      <h4>
        Select customer:
        <el-select
          class="select-info tab"
          placeholder="Single Select"
          v-model="selects.selectCustomer"
          @change="filterCategory()"
        >
          <el-option
            v-for="option in selects.customer"
            class="select-info"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          ></el-option>
        </el-select>
      </h4>
    </div>
    <div class="col-lg-4 style-select">
      <h4>
        Select region:
        <el-select
          class="select-info tab"
          placeholder="Single Select"
          v-model="selects.selectRegion"
          @change="filterCategory()"
        >
          <el-option
            v-for="option in selects.region"
            class="select-info"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          ></el-option>
        </el-select>
      </h4>
    </div>
    <div class="col-lg-4 style-select">
      <h4>
        Select Route:
        <el-select
          class="select-info tab"
          placeholder="Single Select"
          v-model="selects.selectRoute"
          @change="filterCategory()"
        >
          <el-option
            v-for="option in selects.route"
            class="select-info"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          ></el-option>
        </el-select>
      </h4>
    </div>
    <div class="col-lg-12">
      <hr />
    </div>
    <div class="col-md-12">
      <card card-body-classes="table-full-width">
        <div
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <base-input label="rows visible">
            <el-select
              class="select-info mb-3 pagination-select"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </base-input>
          <base-input>
            <el-input
              type="search"
              class="mb-3 search-input"
              clearable
              prefix-icon="el-icon-search"
              placeholder="Search records"
              v-model="searchQuery"
              aria-controls="datatables"
            ></el-input>
          </base-input>
        </div>
        <el-table
          :data="queriedData"
          style="font-size: 12px"
          :header-cell-style="{
            background: 'transparent',
            border: 'none',
            borderBottom: '0.5px solid #3d3f51',
          }"
          :cell-style="{
            border: 'none',
            borderBottom: '0.5px solid #3d3f51',
          }"
        >
          <el-table-column
            min-width="100"
            sortable
            align="center"
            label="customer"
            property="CustName"
          ></el-table-column>
          <el-table-column
            min-width="90"
            sortable
            align="center"
            label="region"
            property="RegionName"
          ></el-table-column>
          <el-table-column
            min-width="100"
            sortable
            align="center"
            label="Route"
            property="RouteName"
          ></el-table-column>
          <el-table-column
            min-width="120"
            sortable
            align="center"
            label="Pickup"
            property="PickupName"
          ></el-table-column>
          <el-table-column
            min-width="120"
            align="center"
            label="Status (C)"
            prop="ColStatus"
          ></el-table-column>
          <el-table-column min-width="85" align="center" label="Picture (C)">
            <div class="photo" slot-scope="{ row }">
              <input
                @click="row.modalCol = true"
                type="image"
                :src="row.defaulPic"
                width="90%"
                height="90%"
              />
              <modal :show.sync="row.modalCol">
                <div class="row">
                  <div class="col-lg-12 text-center">
                    <img :src="row.ColImgPath" />
                  </div>
                </div>
              </modal>
            </div>
          </el-table-column>
          <el-table-column
            min-width="120"
            align="center"
            label="Date (C)"
            prop="ColCreated"
          ></el-table-column>
          <el-table-column
            min-width="120"
            align="center"
            label="Status (I)"
            prop="InspStatName"
          ></el-table-column>
          <el-table-column min-width="80" align="center" label="Picture (I)">
            <div class="photo" slot-scope="{ row }">
              <input
                @click="row.modalInsp = true"
                type="image"
                :src="row.defaulPic"
                width="90%"
                height="90%"
              />
              <modal :show.sync="row.modalInsp">
                <div class="row">
                  <div class="col-lg-12 text-center">
                    <img :src="row.InspImgPath" />
                  </div>
                </div>
              </modal>
            </div>
          </el-table-column>
          <el-table-column
            min-width="120"
            align="center"
            label="Date (I)"
            prop="InspCreated"
          ></el-table-column>
        </el-table>
        <div class="d-flex justify-content-center spinner" v-if="load">
          <circle-8></circle-8>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <base-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></base-pagination>
        </div>
      </card>
    </div>
    <div class="col-lg-6">
      <h6>* ( I ) Inspection, ( C ) Collection</h6>
    </div>
    <div class="col-lg-6 text-right">
      <base-button type="primary" @click="exportCSV(tableData)"
        >Export to CSV</base-button
      >
    </div>
  </div>
</template>
<script>
import config from "@/config";
import { Table, TableColumn } from "element-ui";
import { Select, Option, DatePicker } from "element-ui";
import { Modal } from "src/components";
import { BasePagination } from "src/components";
import Fuse from "fuse.js";
import { Circle8 } from "vue-loading-spinner";
import axios from "axios";
import moment from "moment";
import swal from "sweetalert2";

export default {
  components: {
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    Circle8,
  },
  data() {
    return {
      load: false,
      // Selecting interval data
      selects: {
        selectRegion: "",
        selectCustomer: "",
        selectRoute: "",
        customer: [{ value: "All", label: "All" }],
        region: [{ value: "All", label: "All" }],
        route: [{ value: "All", label: "All" }],
      },
      selectDate: "",
      tableData: [],
      storeData: [],
      searchQuery: "",
      propsToSearch: ["assetNo", "costCenterName"],
      // tableData: [],
      searchedData: [],
      fuseSearch: null,
      currentRow: "",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
    };
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      // Fuse search initialization.
      this.fuseSearch = new Fuse(this.tableData, {
        keys: [
          "CustName",
          "PickupName",
          "RegionName",
          "RouteName",
          "ColStatus",
          "InspStatName",
        ],
        threshold: 0.3,
      });
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
  mounted() {},
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  methods: {
    getDateRange() {
      this.searchQuery = "";
      this.load = true;
      let start = moment(this.selectDate[0]).unix();
      let end = moment(this.selectDate[1]).unix();
      let now = moment().unix();
      if (end > now) {
        swal({
          title: "Date Error!",
          text: `Date should be earlier or equal to today's Date`,
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });
        this.load = false;
      } else {
        this.tableData = [];
        this.storeData = [];
        this.searchedData = [];

        if (start == end) {
          end = moment(this.selectDate[1])
            .add(23, "hours")
            .add(59, "minutes")
            .unix();
        }
        this.$http
          .get(`:9991/api/v1/report/inspection/${start}/${end}`)
          .then((res) => {
            this.storeData = res.message;
            let response = res.message;
            // this.storeData = response;

            this.selects.customer = [{ value: "All", label: "All" }];
            this.selects.region = [{ value: "All", label: "All" }];
            this.selects.route = [{ value: "All", label: "All" }];

            for (let i = 0; i < response.length; i++) {
              // FILTER DATA
              let cust = {
                value: response[i].CustName,
                label: response[i].CustName,
              };
              let region = {
                value: response[i].RegionName,
                label: response[i].RegionName,
              };
              let route = {
                value: response[i].RouteName,
                label: response[i].RouteName,
              };
              this.selects.customer.push(cust);
              this.selects.region.push(region);
              this.selects.route.push(route);

              // TABLE DATA
              let row = {
                CustName: response[i].CustName,
                RegionName: response[i].RegionName,
                RouteName: response[i].RouteName,
                PickupName: response[i].PickupName,
                InspStatName: response[i].InspStatName,
                InspImgPath: `https://afes.vectolabs.com:9991/images/${response[i].InspImgPath}`,
                InspCreated:
                  response[i].InspCreated == ""
                    ? "Not Available"
                    : moment(response[i].InspCreated).format(
                        "YYYY-MM-DD hh:mmA"
                      ),
                ColImgPath: `https://afes.vectolabs.com:9991/images/${response[i].ColImgPath}`,
                ColStatus: response[i].ColStatus,
                ColCreated:
                  response[i].ColCreated == ""
                    ? "Not Available"
                    : moment(response[i].ColCreated).format(
                        "YYYY-MM-DD hh:mmA"
                      ),
                modalCol: false,
                defaulPic:
                  "https://image.flaticon.com/icons/png/512/40/40165.png",
                modalInsp: false,
              };
              this.tableData.push(row);
              this.searchedData.push(row);
              // this.storeData.push(row);
            }
            this.selects.customer = [
              ...new Set(
                this.selects.customer.map((itm) => JSON.stringify(itm))
              ),
            ].map((i) => JSON.parse(i));

            this.selects.region = [
              ...new Set(this.selects.region.map((itm) => JSON.stringify(itm))),
            ].map((i) => JSON.parse(i));

            this.selects.route = [
              ...new Set(this.selects.route.map((itm) => JSON.stringify(itm))),
            ].map((i) => JSON.parse(i));

            this.load = false;
          });
      }
    },
    getInspection() {
      this.load = true;
      this.$http.get(":9991/api/v1/report/inspection").then((res) => {
        this.storeData = res.message;
        let response = res.message;
        for (let i = 0; i < response.length; i++) {
          // FILTER DATA
          let cust = {
            value: response[i].CustName,
            label: response[i].CustName,
          };
          let region = {
            value: response[i].RegionName,
            label: response[i].RegionName,
          };
          let route = {
            value: response[i].RouteName,
            label: response[i].RouteName,
          };
          this.selects.customer.push(cust);
          this.selects.region.push(region);
          this.selects.route.push(route);

          // TABLE DATA
          let row = {
            CustName: response[i].CustName,
            RegionName: response[i].RegionName,
            RouteName: response[i].RouteName,
            PickupName: response[i].PickupName,
            InspStatName: response[i].InspStatName,
            InspImgPath: `https://afes.vectolabs.com:9991/images/${response[i].InspImgPath}`,
            InspCreated:
              response[i].InspCreated == ""
                ? "Not Available"
                : moment(response[i].InspCreated).format("YYYY-MM-DD hh:mmA"),
            ColImgPath: `https://afes.vectolabs.com:9991/images/${response[i].ColImgPath}`,
            ColStatus: response[i].ColStatus,
            ColCreated:
              response[i].ColCreated == ""
                ? "Not Available"
                : moment(response[i].ColCreated).format("YYYY-MM-DD hh:mmA"),
            modalCol: false,
            defaulPic: "https://image.flaticon.com/icons/png/512/40/40165.png",
            modalInsp: false,
          };
          this.tableData.push(row);
          this.searchedData.push(row);
          // this.storeData.push(row);
        }
        this.selects.customer = [
          ...new Set(this.selects.customer.map((itm) => JSON.stringify(itm))),
        ].map((i) => JSON.parse(i));

        this.selects.region = [
          ...new Set(this.selects.region.map((itm) => JSON.stringify(itm))),
        ].map((i) => JSON.parse(i));

        this.selects.route = [
          ...new Set(this.selects.route.map((itm) => JSON.stringify(itm))),
        ].map((i) => JSON.parse(i));

        this.load = false;
      });
    },
    filterCategory() {
      this.searchQuery = "";
      const CUSTOMER = this.selects.selectCustomer;
      const REGION = this.selects.selectRegion;
      const ROUTE = this.selects.selectRoute;
      let listCustomer = [];
      let listRegion = [];
      let listRoute = [];
      this.tableData = [];
      this.searchedData = [];

      if (CUSTOMER == "All" && REGION == "All" && ROUTE == "All") {
        // Store filter value
        this.selects.customer = [{ value: "All", label: "All" }];
        this.selects.region = [{ value: "All", label: "All" }];
        this.selects.route = [{ value: "All", label: "All" }];

        for (let i = 0; i < this.storeData.length; i++) {
          // FILTER DATA
          let cust = {
            value: this.storeData[i].CustName,
            label: this.storeData[i].CustName,
          };
          let region = {
            value: this.storeData[i].RegionName,
            label: this.storeData[i].RegionName,
          };
          let route = {
            value: this.storeData[i].RouteName,
            label: this.storeData[i].RouteName,
          };
          this.selects.customer.push(cust);
          this.selects.region.push(region);
          this.selects.route.push(route);

          let row = {
            CustName: this.storeData[i].CustName,
            RegionName: this.storeData[i].RegionName,
            RouteName: this.storeData[i].RouteName,
            PickupName: this.storeData[i].PickupName,
            InspStatName: this.storeData[i].InspStatName,
            InspImgPath: `https://afes.vectolabs.com:9991/images/${this.storeData[i].InspImgPath}`,
            ColImgPath: `https://afes.vectolabs.com:9991/images/${this.storeData[i].ColImgPath}`,
            InspCreated:
              this.storeData[i].InspCreated == ""
                ? "Not Available"
                : moment(this.storeData[i].InspCreated).format(
                    "YYYY-MM-DD hh:mmA"
                  ),
            ColStatus: this.storeData[i].ColStatus,
            ColCreated:
              this.storeData[i].ColCreated == ""
                ? "Not Available"
                : moment(this.storeData[i].ColCreated).format(
                    "YYYY-MM-DD hh:mmA"
                  ),
            modalCol: false,
            defaulPic: "https://image.flaticon.com/icons/png/512/40/40165.png",
            modalInsp: false,
          };
          this.tableData.push(row);
          this.searchedData.push(row);
        }

        this.selects.customer = [
          ...new Set(this.selects.customer.map((itm) => JSON.stringify(itm))),
        ].map((i) => JSON.parse(i));

        this.selects.region = [
          ...new Set(this.selects.region.map((itm) => JSON.stringify(itm))),
        ].map((i) => JSON.parse(i));

        this.selects.route = [
          ...new Set(this.selects.route.map((itm) => JSON.stringify(itm))),
        ].map((i) => JSON.parse(i));
      } else if (CUSTOMER != "All" && REGION != "All" && ROUTE != "All") {
        for (let i = 0; i < this.storeData.length; i++) {
          if (
            CUSTOMER == this.storeData[i].CustName &&
            REGION == this.storeData[i].RegionName &&
            ROUTE == this.storeData[i].RouteName
          ) {
            let row = {
              CustName: this.storeData[i].CustName,
              RegionName: this.storeData[i].RegionName,
              RouteName: this.storeData[i].RouteName,
              PickupName: this.storeData[i].PickupName,
              InspStatName: this.storeData[i].InspStatName,
              InspImgPath: `https://afes.vectolabs.com:9991/images/${this.storeData[i].InspImgPath}`,
              ColImgPath: `https://afes.vectolabs.com:9991/images/${this.storeData[i].ColImgPath}`,
              InspCreated:
                this.storeData[i].InspCreated == ""
                  ? "Not Available"
                  : moment(this.storeData[i].InspCreated).format(
                      "YYYY-MM-DD hh:mmA"
                    ),
              ColStatus: this.storeData[i].ColStatus,
              ColCreated:
                this.storeData[i].ColCreated == ""
                  ? "Not Available"
                  : moment(this.storeData[i].ColCreated).format(
                      "YYYY-MM-DD hh:mmA"
                    ),
              modalCol: false,
              defaulPic:
                "https://image.flaticon.com/icons/png/512/40/40165.png",
              modalInsp: false,
            };
            this.tableData.push(row);
            this.searchedData.push(row);
          }
        }
      } else if (CUSTOMER != "All" && REGION == "All" && ROUTE == "All") {
        for (let i = 0; i < this.storeData.length; i++) {
          // Store data into table
          if (CUSTOMER == this.storeData[i].CustName) {
            let row = {
              CustName: this.storeData[i].CustName,
              RegionName: this.storeData[i].RegionName,
              RouteName: this.storeData[i].RouteName,
              PickupName: this.storeData[i].PickupName,
              InspStatName: this.storeData[i].InspStatName,
              InspImgPath: `https://afes.vectolabs.com:9991/images/${this.storeData[i].InspImgPath}`,
              ColImgPath: `https://afes.vectolabs.com:9991/images/${this.storeData[i].ColImgPath}`,
              InspCreated:
                this.storeData[i].InspCreated == ""
                  ? "Not Available"
                  : moment(this.storeData[i].InspCreated).format(
                      "YYYY-MM-DD hh:mmA"
                    ),
              ColStatus: this.storeData[i].ColStatus,
              ColCreated:
                this.storeData[i].ColCreated == ""
                  ? "Not Available"
                  : moment(this.storeData[i].ColCreated).format(
                      "YYYY-MM-DD hh:mmA"
                    ),
              modalCol: false,
              defaulPic:
                "https://image.flaticon.com/icons/png/512/40/40165.png",
              modalInsp: false,
            };
            this.tableData.push(row);
            this.searchedData.push(row);
          }
        }
        // Store filter value
        this.selects.region = [{ value: "All", label: "All" }];
        this.selects.route = [{ value: "All", label: "All" }];

        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].CustName == CUSTOMER) {
            let filterRegion = {};
            filterRegion["value"] = this.tableData[i].RegionName;
            filterRegion["label"] = this.tableData[i].RegionName;
            let filterRoute = {};
            filterRoute["value"] = this.tableData[i].RouteName;
            filterRoute["label"] = this.tableData[i].RouteName;
            this.selects.region.push(filterRegion);
            this.selects.route.push(filterRoute);
          }
        }
        this.selects.region = [
          ...new Set(this.selects.region.map((itm) => JSON.stringify(itm))),
        ].map((i) => JSON.parse(i));
        this.selects.route = [
          ...new Set(this.selects.route.map((itm) => JSON.stringify(itm))),
        ].map((i) => JSON.parse(i));
      } else if (CUSTOMER == "All" && REGION != "All" && ROUTE == "All") {
        // Store data into table
        for (let i = 0; i < this.storeData.length; i++) {
          if (REGION == this.storeData[i].RegionName) {
            let row = {
              CustName: this.storeData[i].CustName,
              RegionName: this.storeData[i].RegionName,
              RouteName: this.storeData[i].RouteName,
              PickupName: this.storeData[i].PickupName,
              InspStatName: this.storeData[i].InspStatName,
              InspImgPath: `https://afes.vectolabs.com:9991/images/${this.storeData[i].InspImgPath}`,
              ColImgPath: `https://afes.vectolabs.com:9991/images/${this.storeData[i].ColImgPath}`,
              InspCreated:
                this.storeData[i].InspCreated == ""
                  ? "Not Available"
                  : moment(this.storeData[i].InspCreated).format(
                      "YYYY-MM-DD hh:mmA"
                    ),
              ColStatus: this.storeData[i].ColStatus,
              ColCreated:
                this.storeData[i].ColCreated == ""
                  ? "Not Available"
                  : moment(this.storeData[i].ColCreated).format(
                      "YYYY-MM-DD hh:mmA"
                    ),
              modalCol: false,
              defaulPic:
                "https://image.flaticon.com/icons/png/512/40/40165.png",
              modalInsp: false,
            };
            this.tableData.push(row);
            this.searchedData.push(row);
          }
        }
        // Store filter value
        this.selects.customer = [{ value: "All", label: "All" }];
        this.selects.route = [{ value: "All", label: "All" }];

        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].CustName == REGION) {
            let filterCustomer = {};
            filterCustomer["value"] = this.tableData[i].CustName;
            filterCustomer["label"] = this.tableData[i].CustName;
            let filterRoute = {};
            filterRoute["value"] = this.tableData[i].RouteName;
            filterRoute["label"] = this.tableData[i].RouteName;
            this.selects.customer.push(filterCustomer);
            this.selects.route.push(filterRoute);
          }
        }

        // Remove duplicate key value
        this.selects.customer = [
          ...new Set(this.selects.customer.map((itm) => JSON.stringify(itm))),
        ].map((i) => JSON.parse(i));
        this.selects.route = [
          ...new Set(this.selects.route.map((itm) => JSON.stringify(itm))),
        ].map((i) => JSON.parse(i));
      } else if (CUSTOMER == "All" && REGION == "All" && ROUTE != "All") {
        // Store data into table
        for (let i = 0; i < this.storeData.length; i++) {
          if (ROUTE == this.storeData[i].RouteName) {
            let row = {
              CustName: this.storeData[i].CustName,
              RegionName: this.storeData[i].RegionName,
              RouteName: this.storeData[i].RouteName,
              PickupName: this.storeData[i].PickupName,
              InspStatName: this.storeData[i].InspStatName,
              InspImgPath: `https://afes.vectolabs.com:9991/images/${this.storeData[i].InspImgPath}`,
              ColImgPath: `https://afes.vectolabs.com:9991/images/${this.storeData[i].ColImgPath}`,
              InspCreated:
                this.storeData[i].InspCreated == ""
                  ? "Not Available"
                  : moment(this.storeData[i].InspCreated).format(
                      "YYYY-MM-DD hh:mmA"
                    ),
              ColStatus: this.storeData[i].ColStatus,
              ColCreated:
                this.storeData[i].ColCreated == ""
                  ? "Not Available"
                  : moment(this.storeData[i].ColCreated).format(
                      "YYYY-MM-DD hh:mmA"
                    ),
              modalCol: false,
              defaulPic:
                "https://image.flaticon.com/icons/png/512/40/40165.png",
              modalInsp: false,
            };
            this.tableData.push(row);
            this.searchedData.push(row);
          }
        }
        // Store filter value
        this.selects.customer = [{ value: "All", label: "All" }];
        this.selects.region = [{ value: "All", label: "All" }];

        for (let i = 0; i < this.tableData.length; i++) {
          let filterCustomer = {};
          filterCustomer["value"] = this.tableData[i].CustName;
          filterCustomer["label"] = this.tableData[i].CustName;
          let filterRegion = {};
          filterRegion["value"] = this.tableData[i].RegionName;
          filterRegion["label"] = this.tableData[i].RegionName;
          this.selects.customer.push(filterCustomer);
          this.selects.region.push(filterRegion);
        }

        // Remove duplicate key value
        this.selects.customer = [
          ...new Set(this.selects.customer.map((itm) => JSON.stringify(itm))),
        ].map((i) => JSON.parse(i));
        this.selects.region = [
          ...new Set(this.selects.region.map((itm) => JSON.stringify(itm))),
        ].map((i) => JSON.parse(i));
      } else if (CUSTOMER != "All" && REGION != "All") {
        for (let i = 0; i < this.storeData.length; i++) {
          if (
            CUSTOMER == this.storeData[i].CustName &&
            REGION == this.storeData[i].RegionName
          ) {
            let row = {
              CustName: this.storeData[i].CustName,
              RegionName: this.storeData[i].RegionName,
              RouteName: this.storeData[i].RouteName,
              PickupName: this.storeData[i].PickupName,
              InspStatName: this.storeData[i].InspStatName,
              InspImgPath: `https://afes.vectolabs.com:9991/images/${this.storeData[i].InspImgPath}`,
              ColImgPath: `https://afes.vectolabs.com:9991/images/${this.storeData[i].ColImgPath}`,
              InspCreated:
                this.storeData[i].InspCreated == ""
                  ? "Not Available"
                  : moment(this.storeData[i].InspCreated).format(
                      "YYYY-MM-DD hh:mmA"
                    ),
              ColStatus: this.storeData[i].ColStatus,
              ColCreated:
                this.storeData[i].ColCreated == ""
                  ? "Not Available"
                  : moment(this.storeData[i].ColCreated).format(
                      "YYYY-MM-DD hh:mmA"
                    ),
              modalCol: false,
              defaulPic:
                "https://image.flaticon.com/icons/png/512/40/40165.png",
              modalInsp: false,
            };
            this.tableData.push(row);
            this.searchedData.push(row);
          }
        }
        // Store filter value
        this.selects.route = [{ value: "All", label: "All" }];

        for (let i = 0; i < this.tableData.length; i++) {
          if (
            this.tableData[i].CustName == CUSTOMER &&
            this.tableData[i].RegionName == REGION
          ) {
            let filterRoute = {};
            filterRoute["value"] = this.tableData[i].RouteName;
            filterRoute["label"] = this.tableData[i].RouteName;
            this.selects.route.push(filterRoute);
          }
        }

        // Remove duplicate key value
        this.selects.route = [
          ...new Set(this.selects.route.map((itm) => JSON.stringify(itm))),
        ].map((i) => JSON.parse(i));
      } else if (CUSTOMER != "All" && ROUTE != "All") {
        for (let i = 0; i < this.storeData.length; i++) {
          if (
            CUSTOMER == this.storeData[i].CustName &&
            ROUTE == this.storeData[i].RouteName
          ) {
            let row = {
              CustName: this.storeData[i].CustName,
              RegionName: this.storeData[i].RegionName,
              RouteName: this.storeData[i].RouteName,
              PickupName: this.storeData[i].PickupName,
              InspStatName: this.storeData[i].InspStatName,
              InspImgPath: `https://afes.vectolabs.com:9991/images/${this.storeData[i].InspImgPath}`,
              ColImgPath: `https://afes.vectolabs.com:9991/images/${this.storeData[i].ColImgPath}`,
              InspCreated:
                this.storeData[i].InspCreated == ""
                  ? "Not Available"
                  : moment(this.storeData[i].InspCreated).format(
                      "YYYY-MM-DD hh:mmA"
                    ),
              ColStatus: this.storeData[i].ColStatus,
              ColCreated:
                this.storeData[i].ColCreated == ""
                  ? "Not Available"
                  : moment(this.storeData[i].ColCreated).format(
                      "YYYY-MM-DD hh:mmA"
                    ),
              modalCol: false,
              defaulPic:
                "https://image.flaticon.com/icons/png/512/40/40165.png",
              modalInsp: false,
            };
            this.tableData.push(row);
            this.searchedData.push(row);
          }
        }
        // Store filter value
        this.selects.region = [{ value: "All", label: "All" }];
        for (let i = 0; i < this.tableData.length; i++) {
          if (
            this.tableData[i].CustName == CUSTOMER &&
            this.tableData[i].RouteName == ROUTE
          ) {
            let filterRegion = {};
            filterRegion["value"] = this.tableData[i].RegionName;
            filterRegion["label"] = this.tableData[i].RegionName;
            this.selects.region.push(filterRegion);
          }
        }

        // Remove duplicate key value
        this.selects.region = [
          ...new Set(this.selects.region.map((itm) => JSON.stringify(itm))),
        ].map((i) => JSON.parse(i));
      } else if (REGION != "All" && ROUTE != "All") {
        for (let i = 0; i < this.storeData.length; i++) {
          if (
            REGION == this.storeData[i].RegionName &&
            ROUTE == this.storeData[i].RouteName
          ) {
            let row = {
              CustName: this.storeData[i].CustName,
              RegionName: this.storeData[i].RegionName,
              RouteName: this.storeData[i].RouteName,
              PickupName: this.storeData[i].PickupName,
              InspStatName: this.storeData[i].InspStatName,
              InspImgPath: `https://afes.vectolabs.com:9991/images/${this.storeData[i].InspImgPath}`,
              ColImgPath: `https://afes.vectolabs.com:9991/images/${this.storeData[i].ColImgPath}`,
              InspCreated:
                this.storeData[i].InspCreated == ""
                  ? "Not Available"
                  : moment(this.storeData[i].InspCreated).format(
                      "YYYY-MM-DD hh:mmA"
                    ),
              ColStatus: this.storeData[i].ColStatus,
              ColCreated:
                this.storeData[i].ColCreated == ""
                  ? "Not Available"
                  : moment(this.storeData[i].ColCreated).format(
                      "YYYY-MM-DD hh:mmA"
                    ),
              modalCol: false,
              defaulPic:
                "https://image.flaticon.com/icons/png/512/40/40165.png",
              modalInsp: false,
            };
            this.tableData.push(row);
            this.searchedData.push(row);
          }
        }
        // Store filter attributes based on data table value
        this.selects.customer = [{ value: "All", label: "All" }];

        for (let i = 0; i < this.tableData.length; i++) {
          if (
            this.tableData[i].RegionName == REGION &&
            this.tableData[i].RouteName == ROUTE
          ) {
            let filterCustomer = {};
            filterCustomer["value"] = this.tableData[i].CustName;
            filterCustomer["label"] = this.tableData[i].CustName;
            this.selects.customer.push(filterCustomer);
          }
        }

        // Remove duplicate key value
        this.selects.customer = [
          ...new Set(this.selects.customer.map((itm) => JSON.stringify(itm))),
        ].map((i) => JSON.parse(i));
      }
    },
    exportCSV(data) {
      let csvData = this.$CSV(this.tableData);
      const blob = new Blob([csvData], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.setAttribute("hidden", "");
      a.setAttribute("href", url);
      a.setAttribute("download", "InspectionReport.csv");
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  },
  created() {
    this.selects.selectRoute = this.selects.route[0].value;
    this.selects.selectCustomer = this.selects.customer[0].value;
    this.selects.selectRegion = this.selects.region[0].value;
    this.getInspection();
  },
};
</script>
<style lang="scss" scoped>
.inline {
  margin-top: 1.5%;
  margin-bottom: 0.5%;
}
.describe {
  font-size: 90%;
  font-style: italic;
}
hr {
  color: black;
  margin-top: 0%;
}
.style-date {
  margin-bottom: 1%;
}
.style-select {
  padding-top: 1%;
}
</style>
